/**
 * 언어 추가시 안내:
 * `TargetLanguage`, `language.constants.ts(languageMap, languageOrder)`, `countries.ts` 만 수정하면 반영됨
 *
 * @todo 장기적으로 언어 하드코딩된 부분 모두 제거 필요
 */
export enum TargetLanguage {
  KOREAN = 'ko',
  JAPANESE = 'ja',
  ENGLISH = 'en',
  THAI = 'th',
  CHINESE_SIMPLIFIED = 'zh-Hans', // 국가는 zh-Hans-CN
  CHINESE_TRADITIONAL = 'zh-Hant', // 국가는 zh-Hant-TW
}
